import React from 'react'
import '../Services/Services.css';
import img0 from "../../img/about2.jpg";
import img01 from "../../img/a1.jpg";
import img02 from "../../img/a2.jpg";
import img03 from "../../img/a3.jpg";
import img04 from "../../img/a4.jpg";
import img05 from "../../img/a5.jpg";
import img06 from "../../img/a6.jpg";
import img07 from "../../img/a7.jpg";
import img08 from "../../img/a8.jpg";


function Services() {
  return (
    <>
      <section className="about-section1 d-flex align-items-center">
        <div className="container text-center text-white">
          <h1 className="fw-bold">Our Services</h1>
        </div>
      </section>

      <section className="help-section container">
        {/* <div class="help-title">
    <h2>How We Help You</h2>
    <p class="text-muted">We provide expert property solutions to make your life easier</p>
  </div> */}


        {/* <div className="help-card">
          

        

        
        
       

        <div className="help-card">

         

        <div className="help-card">
          <img src={img06} alt="Showing Property" />
          <div>
            <h4>Theme Parties</h4>
            <p>Our aim is to create themed events and concepts that will, “WOW” your guests, exceed your expectations and make your event a memorable experience. If you are looking for something unique, we can give you some fresh ideas to bring your themed function to life.</p>
          </div>
        </div>

        <div className="help-card">

          <div>
            <h4>Conferences and Conventions</h4>
            <p>These are typically sit down events and mostly a ‘white gloved’ service affair with customized menu selections for limited group of people. Break Fasts, Lunches, Evening Tea-Coffee and Snacks, Diners is our prime offering, however we also specialize in setting up customized service counters for Sandwiches, Specialty Teas, Fruit & Juices etc.</p>
          </div>
          <img src={img07} alt="Showing Property" />
        </div>

        <div className="help-card">
          <img src={img08} alt="Showing Property" />
          <div>
            <h4>Special Occasions</h4>
            <p>We provide unmatched catering food options for all festivals like Diwali, Eid, Christmas, Holi, etc. We add meaning to your religious sentiments with food specially prepared for the festive occasion keeping in mind the religious significance and sentiments while catering to festival events. For social events such Independence Day and Republic Day we offer theme based menus.</p>
          </div>
        </div> */}
        

        <section className="about-us py-5">
          <div className="container">
            <div className="row align-items-center mb-3">
              <div className="col-lg-7">
                <h2 className="fw-bold mb-3" style={{ color: '#cf6511' }}>Wedding Catering</h2>
                <p>At Raju Caterer, we are dedicated to creating an experience so majestic, it becomes a lifelong memory.
                  Weddings are once-in-a-lifetime occasions, and we understand how important it is to get every detail just right. With years of expertise in wedding catering, our specialized team ensures flawless service, exquisite cuisine, and seamless execution from start to finish</p>
                <p>We also understand that guest counts can change—especially in Indian weddings. That’s why our team is always prepared to adapt quickly and efficiently, making sure every additional guest is served with the same level of care and hospitality.</p>
              </div>
              <div className="col-lg-5 mb-lg-0">
                <img src={img0} alt="About Us" className="img-fluid rounded shadow" />
              </div>
            </div>

            <div className="row align-items-center mb-3">
              <div className="col-lg-5 mb-lg-0">
                <img src={img01} alt="About Us" className="img-fluid rounded shadow" style={{ width: '500px', height: '350px' }} />
              </div>
              <div className="col-lg-7">
                <h2 className="fw-bold mb-3" style={{ color: '#cf6511' }}>Baby Showers</h2>

                <p>A baby shower is a beautiful celebration of new life, love, and family. It's a time for close friends and loved ones to come together and shower the mum-to-be with blessings, joy, and thoughtful gifts as she prepares to welcome her little one.</p>
                <p>At Raju Caterer, we understand how special this occasion is. That’s why we offer expertly crafted baby shower catering services, so you can focus on making memories while we take care of the rest. From elegant snacks and sweets to full-course meals, our menus are thoughtfully designed to suit the tone of your celebration.</p>
              </div>

            </div>

            <div className="row align-items-center mb-3">
              <div className="col-lg-7">
                <h2 className="fw-bold mb-3" style={{ color: '#cf6511' }}>Birthday Parties</h2>

                <p>At Raju Caterer, we make your celebration even more memorable with delicious food and seamless service. Our birthday catering packages are designed to suit all age groups and party styles — from fun and playful themes to elegant and traditional gatherings.</p>
                <p>With a wide range of menu options tailored for birthday occasions, we ensure that your guests enjoy every bite while you focus on creating joyful memories.</p>
              </div>
              <div className="col-lg-5 mb-lg-0">
                <img src={img02} alt="About Us" className="img-fluid rounded shadow" style={{ width: '500px', height: '350px' }} />
              </div>
            </div>

            <div className="row align-items-center mb-3">
              <div className="col-lg-5 mb-lg-0">
                <img src={img04} alt="About Us" className="img-fluid rounded shadow" style={{ width: '500px', height: '350px' }} />
              </div>
              <div className="col-lg-7">
                <h2 className="fw-bold mb-3" style={{ color: '#cf6511' }}>Religious Catering</h2>

                <p>Religious events hold deep cultural and spiritual significance in our lives. At Raju Caterer, we truly understand the diversity of Indian traditions and the importance of honoring religious customs through food.</p>
                <p>Whether you're planning a puja, havan, community prayer, or any spiritual gathering, we ensure that the food is prepared with the utmost purity and in accordance with your specific religious practices. From satvik meals to no-onion-no-garlic dishes and other dietary requirements, our team is experienced in delivering food that respects your beliefs.</p>
              </div>

            </div>

            <div className="row align-items-center">
              <div className="col-lg-7">
                <h2 className="fw-bold mb-3" style={{ color: '#cf6511' }}>Corporate Catering</h2>

                <p>Making your event truly memorable requires more than just great food — it takes creativity, attention to detail, and professional execution. At Raju Caterer, we bring all of that and more to your corporate and special events.</p>
                <p>Whether it's a product launch, a formal cocktail dinner, or a casual finger food buffet, we have the expertise to cater to events of all sizes and styles. Our specially trained staff are well-groomed, courteous, and experienced in handling high-profile gatherings with precision and grace.</p>
              </div>
              <div className="col-lg-5 mb-lg-0">
                <img src={img03} alt="About Us" className="img-fluid rounded shadow" style={{ width: '500px', height: '350px' }} />
              </div>
            </div>

            <div className="row align-items-center mb-3">
              <div className="col-lg-5 mb-lg-0">
                <img src={img05} alt="About Us" className="img-fluid rounded shadow" style={{ width: '500px', height: '350px' }} />
              </div>
              <div className="col-lg-7">
                <h2 className="fw-bold mb-3" style={{ color: '#cf6511' }}>Festive Celebrations</h2>

                <p>Festivals are all about joy, togetherness, and unforgettable food. At Raju Caterer, we bring the spirit of every celebration to life with delicious and thoughtfully crafted menus tailored just for you.</p>
                <p>From classic traditional feasts to modern, contemporary spreads, we cater to all festive occasions — Diwali, Eid, Christmas, Holi, Pongal, and more. Our team works closely with you to create a bespoke menu that reflects your taste, traditions, and the essence of the festival.</p>
              </div>

            </div>

            <div className="row align-items-center">
              <div className="col-lg-7">
                <h2 className="fw-bold mb-3" style={{ color: '#cf6511' }}>Theme Parties</h2>


                <p>At Raju Caterer, our goal is to create themed events that WOW your guests, exceed your expectations, and turn your celebration into a truly unforgettable experience.</p>
                <p>Whether you're planning a traditional cultural event, a glamorous Bollywood night, a retro party, or something entirely out-of-the-box — we specialize in turning creative concepts into reality. From decor coordination to custom menus, we ensure every detail complements your theme perfectly.</p>
              </div>
              <div className="col-lg-5 mb-lg-0">
                <img src={img06} alt="About Us" className="img-fluid rounded shadow" style={{ width: '500px', height: '350px' }} />
              </div>
            </div>

            <div className="row align-items-center">
              <div className="col-lg-5 mb-lg-0">
                <img src={img07} alt="About Us" className="img-fluid rounded shadow" style={{ width: '500px', height: '350px' }} />
              </div>
              <div className="col-lg-7">
                <h2 className="fw-bold mb-3" style={{ color: '#cf6511' }}>Conferences and Conventions</h2>


                <p>At Raju Caterers, we specialize in hosting exclusive sit-down events, where white-glove service and personalized attention define the experience. Each event is crafted with a customized menu, curated to suit a limited group of discerning guests.</p>
                <p>Our core offerings include elegant breakfasts, lunches, evening tea/coffee with gourmet snacks, and formal dinners. Beyond these, we take pride in setting up bespoke service counters featuring freshly prepared sandwiches, specialty teas, seasonal fruits, and fresh juices—all tailored to your preferences.</p>
              </div>

            </div>

            <div className="row align-items-center">
              <div className="col-lg-7">
                <h2 className="fw-bold mb-3" style={{ color: '#cf6511' }}>Special Occasions</h2>


                <p>At Raju Caterers, we offer unmatched catering services for all major festivals, including Diwali, Eid, Christmas, Holi, and more. Our festive menus are thoughtfully crafted to honor the religious significance and cultural sentiments of each celebration. We take pride in preparing food that not only delights the palate but also adds meaning to your festive gatherings.</p>
                <p>For national celebrations such as Independence Day and Republic Day, we create theme-based menus that reflect the spirit of the occasion—making your event both memorable and meaningful.</p>
              </div>
              <div className="col-lg-5 mb-lg-0">
                <img src={img08} alt="About Us" className="img-fluid rounded shadow" style={{ width: '500px', height: '350px' }} />
              </div>
            </div>
          </div>
        </section>

      </section>
    </>
  )
}

export default Services
